module.exports = __webpack_public_path__ + "static/img/SaoPauloJoao0256.6ce5420.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/SaoPauloJoao0256.jpg
// module id = vaf/
// module chunks = 0